import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Spinner,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaPlay, FaTrash } from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { PatternFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import { goToAddContasFixas } from "../../../routes/coordinator";
import { JWTToken } from "../../../routes/privateRoute";
import ClientApi from "../../../services/clientApi";
import SysTypesApi from "../../../services/sysTypesApi";
import jwt_decode from "jwt-decode";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import { useRecoilState, useSetRecoilState } from "recoil";
import { HamburgerIcon } from "@chakra-ui/icons";
import { CNPJFormater, CPFFormater } from "../../../defaultFunctions/formaters";
import DeleteAccount from "./components/deleteAccount";
import { customColors } from "../../../atoms/customColors";


export default function ContaFixa() {
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const cliente = Number(jwtToken.idCliente);
  const refresh = useRecoilState(refreshGlobal)[0];
  const colors = useRecoilState(customColors)[0];

  const navigate = useNavigate();
  const [account, setAccount] = useState(
    Array<{
      id: number;
      idCliente: number;
      idTipoConta: number;
      nomeTitular: string;
      docTitular: string;
      nroAgencia: string;
      nroConta: string;
      nroAgenciaDigito: string;
      nroContaDigito: string;
      nroBanco: string;
      isRecAutomatico: boolean;
      isSplit: boolean;
      porcentagemSplit: number;
    }>
  );

  async function getAccountsList() {
    try {
      const response = await ClientApi.getClientAccounts(cliente, 1, 100);
      setAccount(response.data);
    } catch (error) {
      console.log("error: ", error);
    }
  }
  useEffect(() => {
    getAccountsList();
  }, [refresh]);
  const [open, setOpen] = useState(false);
  const [idAccount, setIdAccount] = useState(0);

  return (
    <Flex
      w={"99.5%"}
      h={"99.5%"}
      flexDirection={"column"}
      bgColor={"#F5F5F5"}
      //   justifyContent={"center"}
      alignItems={"center"}
      overflowY="scroll"
    >
      <Flex
        w={"98%"}
        h={"8%"}
        alignItems={"center"}
        mx={2}
        // borderBottom={`2px solid ${BLUEMONEDD}`}
      >
        <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
        <Text 
          color={colors.BLUEMONEDDBUTTONS} // colors.BLUEMONEDD cor original
          fontSize={"35px"} 
          fontWeight={"bold"} 
          ml={2}
        >
          CONTA FIXA
        </Text>
      </Flex>
      <Flex
        w={"98%"}
        h={"7%"}
        alignItems={"center"}
        mx={2}
        // borderBottom={`2px solid ${BLUEMONEDD}`}
      >
        <Text 
          color={colors.BLUEMONEDDBUTTONS} // colors.BLUEMONEDD cor original 
          fontSize={"20px"} 
          fontWeight={"600"} 
          ml={2}
        >
          Cadastre mais de uma conta para recebimento direto
        </Text>
      </Flex>
      <Flex
        w={"98%"}
        h={"7%"}
        alignItems={"center"}
        mx={2}
        flexDir={"row"}
        // borderBottom={`2px solid ${BLUEMONEDD}`}
      >
        <Button
          bgColor={colors.BLUEMONEDDBUTTONS}
          color={colors.WHITE}
          mx={4}
          fontSize={"20px"}
          _hover={{ background: "#c3c3c3", color: `${colors.BLUEMONEDD}` }}
          onClick={() => {
            goToAddContasFixas(navigate);
          }}
        >
          NOVO CADASTRO
        </Button>
        {/* <Button
          bgColor={BLUEMONEDDBUTTONS}
          color={WHITE}
          mx={4}
          fontSize={"20px"}
          _hover={{ background: "#c3c3c3", color: `${BLUEMONEDD}` }}
        >
          EDITAR CADASTRO
        </Button> */}
      </Flex>
      <Flex
        w={"98%"}
        justifyContent={"center"}
        // px={6}
        mt="2%"
        bgColor={"WHITE"}
        borderRadius={"15px"}
      >
        <TableContainer borderRadius="8px">
          <Table variant="striped" colorScheme="gray" overflowY="scroll">
            <Thead h="60px">
              <Tr>
                <Th
                  w={"300px"}
                  borderRadius={"0 0 0 8px"}
                  // textAlign={"center"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  NOME
                </Th>
                <Th
                  w={"300px"}
                  // textAlign={"center"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  CPF/CNPJ
                </Th>
                <Th
                  w={"300px"}
                  // textAlign={"center"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  BANCO
                </Th>
                <Th
                  w={"300px"}
                  // textAlign={"center"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  AGÊNCIA
                </Th>
                <Th
                  w={"300px"}
                  // textAlign={"center"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  CONTA
                </Th>
                <Th
                  w={"300px"}
                  // textAlign={"center"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  TIPO DE CONTA
                </Th>
                <Th
                  w={"300px"}
                  borderRadius={"0 0 8px 0"}
                  // textAlign={"center"}
                  bgColor={colors.BLUEMONEDDBUTTONS}
                  color={colors.WHITE}
                >
                  OPÇÕES
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {account ? (
                account.map((item) => {
                  console.log("item", item);
                  return (
                    <Tr key={item.id}>
                      <Td>{item.nomeTitular}</Td>
                      <Td>
                        {item.docTitular.length === 11
                          ? CPFFormater(item.docTitular)
                          : CNPJFormater(item.docTitular)}
                      </Td>
                      <Td>{item.nroBanco}</Td>
                      <Td>
                        {item.nroAgencia &&
                          item.nroAgencia.replace("-", "").replace("D", "") +
                            (item.nroAgenciaDigito
                              ? "-" + item.nroAgenciaDigito
                              : "")}
                      </Td>
                      <Td>{item.nroConta}</Td>
                      <Td>
                        {item.idTipoConta === 1 ? "Corrente" : "Poupança"}
                      </Td>
                      <Td>
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            aria-label="Options"
                            icon={<HamburgerIcon />}
                            bgColor={colors.BLUEMONEDDBUTTONS}
                            color={colors.WHITE}
                            size={"sm"}
                          />
                          <MenuList>
                            <MenuItem
                              icon={<FaTrash />}
                              onClick={() => {
                                setIdAccount(item.id);
                                setOpen(true);
                                // openDeleteModal(item.id);
                              }}
                            >
                              Excluir
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <Flex
                  w={"50vw"}
                  height={"20vh"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Spinner size={"lg"} color={colors.VARIANT} />
                </Flex>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        <DeleteAccount
          isOpen={open}
          setIsOpen={setOpen}
          idClient={cliente}
          idAccount={idAccount}
        />
      </Flex>
    </Flex>
  );
}
